import React from 'react'
import type { SubscriptionData } from 'types/subscription'
import AmexIcon from 'assets/icons/amex-icon.svg'
import discoverIcon from 'assets/icons/discover-icon@2x.jpg'
import MastercardIcon from 'assets/icons/mastercard-icon.svg'
import visaIcon from 'assets/icons/visa-icon@2x.jpg'
import List from 'components/ui/list'
import ListItemWithIcon from 'components/ui/list-item-with-icon'
import styles from './index.module.css'

const listIcon = {
  visa: visaIcon,
  mastercard: <MastercardIcon width={35} />,
  american_express: <AmexIcon width={35} />,
  discover: discoverIcon,
}

/**
 * CardNumber component for displaying credit card information
 *
 * Displays the credit card type with its corresponding icon and the last 4 digits
 * of the card number. Shows a loading state while subscription data is being fetched.
 *
 * @param props - Component props
 * @param props.subscription - Subscription data containing card information
 * @returns JSX element displaying the card number and type
 */
const CardNumber = ({
  subscription,
}: {
  subscription: SubscriptionData
}): React.ReactNode => {
  let cardEnding = ''
  let cardType = ''
  let iconNode: React.ReactNode = ''

  const subscriptionData = subscription.loaded ? subscription.chargebee : null

  if (!subscription.loading) {
    const originalCardType = subscriptionData?.card_type

    if (originalCardType) {
      const cardTypeIcon = listIcon[originalCardType]

      if (cardTypeIcon) {
        if (typeof cardTypeIcon !== 'string') {
          iconNode = cardTypeIcon
        } else {
          iconNode = <img src={cardTypeIcon} width={35} />
        }
      }

      cardType = originalCardType?.replace('_', ' ')
    }

    cardEnding = subscriptionData?.last_segment_of_card_number ?? ''
  }

  return (
    <List>
      <ListItemWithIcon iconNode={iconNode}>
        {subscription.loading ? (
          'Loading...'
        ) : (
          <>
            <span className={styles.cardNumberCardType}>{cardType} </span>
            ending in {cardEnding}
          </>
        )}
      </ListItemWithIcon>
    </List>
  )
}

export default CardNumber
